import actionCreatorFactory from 'typescript-fsa'
import { ErrorResponse, User } from '~api/models'
import { MsalAccountInfo } from '~shared/models/msalExtendedTypes'

const actionCreator = actionCreatorFactory('ACCOUNT')

/**
 * Actions
 */
export const signInComplete = actionCreator<MsalAccountInfo>('SIGN_IN_COMPLETE')
export const signOutComplete = actionCreator<void>('SIGN_OUT_COMPLETE')

export const fetchUser = actionCreator.async<void, User, ErrorResponse>('FETCH_USER')
